<template>
  <svg width="19" height="23" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 12.5L17 6L12 1L1 0.999999L1 22L7 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>
    <path d="M10 19L14 15L18 19" stroke="currentColor" stroke-width="1.5"/>
    <path d="M14 15L14 23" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>
